import { Route } from 'src/routes/Route'

export const DraftedCardsRoute = Route({ path: '/drafted-cards' })
export type DraftedCardsRoute = Route<typeof DraftedCardsRoute>
